import React from "react";
import Button from "../../pages/ui/Button";

interface ProfileCardProps {
  title: string;
  data: { label: string; value: any }[];
  buttonLabel: string;
  onButtonClick: () => void;
}

const ProfileCard: React.FC<ProfileCardProps> = ({
  title,
  data,
  buttonLabel,
  onButtonClick,
}) => {
  return (
    <div className="bg-white  rounded-3xl">
      <h2 className="text-lg font-semibold mb-4 border-b border-borderColor py-6 px-6">
        {title}
      </h2>
      <div className="space-y-4 p-6">
        {data.map((item, index) => (
          <div key={index} className="flex gap-2 items-center">
            <span className="text-sm text-gray-500">{item.label}: </span>
            <span className="font-medium">{item.value}</span>
          </div>
        ))}
      </div>
      <Button
        onClick={onButtonClick}
        label={buttonLabel}
        layout="inline" classNames="m-5"
      />
    </div>
  );
};

export default ProfileCard;
